(function () {
  'use strict';

  angular
    .module('crewCreditHoursReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('crewCreditHoursReport', {
        url: '/crew-credit-hours-details-report',
        views : {
        	'crewCreditHoursReportView' : {
        		templateUrl: 'crew-credit-hours-details-report/views/crew-credit-hours-report.tpl.html',
                controller: 'crewCreditHoursReportCtrl',
                controllerAs: 'crewCreditHoursReport'
        	}
        }
      });
  }
}());
